import { render, staticRenderFns } from "./PageOthers.vue?vue&type=template&id=3007bd0e&scoped=true"
import script from "./PageOthers.vue?vue&type=script&lang=js"
export * from "./PageOthers.vue?vue&type=script&lang=js"
import style0 from "./PageOthers.vue?vue&type=style&index=0&id=3007bd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3007bd0e",
  null
  
)

export default component.exports